import * as updateCultureById from "@/api/cultures/update";

export default {
	namespaced: true,
	state: {
		role: {},
		id: "",
		error: null,
	},
	getters: {
		readCulture: (state) => state.role,
		readId: (state) => state.id,
		readError: (state) => state.error,
	},
	mutations: {
		SET_CULTURE(state, payload) {
			state.role = payload;
		},
		SET_ID(state, payload) {
			state.id = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async updateCulture({ commit, getters, rootGetters }) {
			const token = rootGetters['loginStore/readToken'];
			const updateCultureRes = await updateCultureById
				.updateCulture(token,getters.readId, getters.readCulture)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});

			return updateCultureRes;
		},
	},
};
